import * as React from "react";
import { useState } from "react";

import { Field, withTypes } from "react-final-form";
import axios from "axios";

import {
  Button,
  CardActions,
  CircularProgress,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { Notification, useTranslate, useNotify } from "react-admin";

import { ENDPOINTS } from "../apiConstants";
import { getConfigGet } from "../getConfig";
import { ShowData } from "./transferRewardAmount";

const useStyles = makeStyles((theme) => ({
  main: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  card: {
    minWidth: 300,
    marginTop: "6em",
  },
  avatar: {
    margin: "1em",
    display: "flex",
    justifyContent: "center",
  },
  form: {
    padding: "0 1em 1em 1em",
  },
  input: {
    marginTop: "1em",
  },
  actions: {
    padding: "0 1em 1em 1em",
  },
  resultsContainer: {
    marginTop: "2em",
    width: "100%",
    maxWidth: "800px",
  },
  alignment: {
    margin: '0 15%'
  }
}));

const renderInput = ({
  meta: { touched, error } = { touched: false, error: undefined },
  input: { ...inputProps },
  ...props
}: any) => (
  <TextField
    error={!!(touched && error)}
    helperText={touched && error}
    {...inputProps}
    {...props}
    fullWidth
  />
);

interface FormValues {
  Email?: string;
}

const { Form } = withTypes<FormValues>();

const DeleteVrpConsent = () => {
  const translate = useTranslate();
  const classes = useStyles();
  const notify = useNotify();

  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [vrpConsents, setVrpConsents] = useState([]);
  const [userEmail, setUserEmail] = useState("");

  const handleFetchConsents = (inputData: any) => {
    setVrpConsents([]);
    setUserEmail(inputData.Email);
    setLoading(true);
    notify("Fetching VRP consent data...", "info");

    const config = getConfigGet({ email: inputData.Email });

    axios.get(ENDPOINTS.DELETE_VRP_CONSENT, config)
      .then((res: any) => {
        setVrpConsents(res.data || []);
        setLoading(false);
        notify("VRP consent data fetched successfully", "info", "", undefined, 5000);
      })
      .catch((error) => {
        setLoading(false);
        notify(error?.response?.data?.message || 'Failed to fetch VRP consent data', "error", "", undefined, 5000);
      });
  };

  const handleDeleteConsent = (consentId: string) => {
    setDeleteLoading(true);
    notify("Deleting VRP consent...", "info");

    const config = getConfigGet({ email: userEmail });

    axios.delete(`${ENDPOINTS.DELETE_VRP_CONSENT}/${consentId}`, config)
      .then((res: any) => {
        // Remove the deleted consent from the list
        setVrpConsents(prev => prev.filter((consent: any) => consent.id !== consentId));
        setDeleteLoading(false);
        notify("VRP consent deleted successfully", "info", "", undefined, 5000);
      })
      .catch((error) => {
        setDeleteLoading(false);
        console.error("Delete consent error:", error);
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete VRP consent';
        notify(errorMessage, "error", "", undefined, 10000);
      });
  };

  const validate = (values: FormValues) => {
    const errors: FormValues = {};
    if (!values.Email) {
      errors.Email = translate("ra.validation.required");
    }
    return errors;
  };



  return (
    <>
      <Form
        onSubmit={() => {}} // Empty onSubmit since we handle clicks directly
        validate={validate}
        render={({ values }) => (
          <div>
            <div className={classes.main}>
              <div className={classes.form}>
                <div className={classes.input}>
                  <Field
                    autoFocus
                    name="Email"
                    component={renderInput}
                    label="User Email"
                    disabled={loading}
                  />
                </div>
              </div>
              <CardActions className={classes.actions}>
                <Button
                  variant="contained"
                  color='primary'
                  disabled={loading || !values.Email}
                  fullWidth
                  onClick={() => handleFetchConsents(values)}
                >
                  {loading && <CircularProgress size={25} thickness={2} />}
                  Fetch VRP Consents
                </Button>
              </CardActions>
              <Notification />
            </div>

            {vrpConsents.length > 0 && (
              <div className={classes.resultsContainer}>
                <div className={classes.alignment}>
                  <ShowData record={vrpConsents} tableCenterAlign={false} />
                </div>
                <div className={classes.alignment} style={{ 
                  textAlign: "right", 
                  marginTop: "2em" 
                }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => handleDeleteConsent(vrpConsents[1][0])}
                    disabled={deleteLoading}
                  >
                    {deleteLoading && <CircularProgress size={25} thickness={2} />}
                    Delete VRP Consent
                  </Button>
                </div>
              </div>
            )}

            {vrpConsents.length === 0 && userEmail && !loading && (
              <div style={{ textAlign: "center", marginTop: "2em" }}>
                <p>No VRP consents found for this user.</p>
              </div>
            )}
          </div>
        )}
      />
    </>
  );
};

export default DeleteVrpConsent;
